import React from "react";
import { Rect } from "react-konva";
import { mergeRefs } from "../../../../utils/mergeRef";
import { ShapeCommonProps } from "../../types";
import { useShape } from "../ShapeContext/useShape";

export const RectShape = React.forwardRef<
  React.ComponentRef<typeof Rect>,
  ShapeCommonProps
>((commonProps, ref) => {
  const { shape } = useShape();

  const shapeRef = React.useRef<React.ComponentRef<typeof Rect>>(null);

  return (
    <Rect
      {...commonProps}
      width={shape.width}
      height={shape.height}
      fill={shape.noFill ? undefined : shape.color}
      stroke={shape.stroke || "transparent"}
      strokeWidth={shape.strokeWidth || 0}
      opacity={shape.locked ? 0.5 : 1}
      ref={mergeRefs([shapeRef, ref])}
      cornerRadius={shape.cornerRadius || 0}
    />
  );
});
